import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getLocalizedString } from "@icarius-localization/strings";
import { getCentersRows, getLoading } from "../selectors";
import ABMLayout from "@icarius-common/abmComponents/abmLayout";
import { Grid } from "@material-ui/core";
import DataItem from "./data/dataItem";
import { getCentersSettingsAction } from "../actions";
import { RESET_STATE } from "../actionTypes";

const CentersSettings = () => {

  const [createIsOpen, setCreateIsOpen] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getCentersSettingsAction());
    return () => dispatch({ type: RESET_STATE })
  }, [dispatch])

  const rows = useSelector(getCentersRows);
  const isLoading = useSelector(getLoading);

  const getDataIsEmpty = () => {
    return !rows || rows.length === 0;
  }

  return (
    <ABMLayout
      title={getLocalizedString("centersSettings")}
      audioName={"Centros de gestión de publicaciones"}
      audioTitle={getLocalizedString("centersSettings")}
      isLoading={isLoading}
      showCreateButton={!createIsOpen}
      createButtonTitle={getLocalizedString("newCenter")}
      createButtonOnClick={() => setCreateIsOpen(true)}
      showNoData={getDataIsEmpty()}
      noDataTitle={getLocalizedString("noCentersFound")}
      noDataCreateTitle={getLocalizedString("newCenter")}
      noDataOnClick={() => setCreateIsOpen(true)}
    >
      <Grid container item xs={12} direction="row">
        {
          createIsOpen &&
          <Grid container item xs={12} style={{ margin: "10px 0px" }}>
            <DataItem
              data={null}
              closeNew={() => setCreateIsOpen(false)}
            />
          </Grid>
        }
        {
          rows && rows.map((item) => {
            return (
              <Grid container item xs={12} style={{ margin: "10px 0px" }} key={item.internalCode}>
                <DataItem data={item} />
              </Grid>
            )
          })
        }
      </Grid>
    </ABMLayout>
  );
}

export default CentersSettings;
